export const dropNonSignificantZeros = (num: number | string | undefined) => {
  if (!num) return
  return Number(num)
}